export default __webpack_public_path__ + "04cd6584ff112ff95b5d674077dc651a.png";